import { useState, useEffect, useContext } from 'react';
import { State, StateContext } from '../state';

const LocationTracker = () =>  {
  const [location, setLocation] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const { setMyPos } = useContext(StateContext) as State;


  useEffect(() => {
    if (!("geolocation" in navigator)) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    if (window.location.href.startsWith("http://localhost:3000/")) {
      const mock = {
        latitude: -8.69193,
        longitude: 115.51529,
      };
      setLocation(mock);
      setMyPos(mock);
      return; // su localhost usiamo il mock e non chiediamo il permesso reale
    }

    // Evita di sovrascrivere una posizione già ottenuta da un eventuale
    // secondo callback (es. fallback) arrivato dopo il primo successo.
    let resolved = false;

    const onSuccess = (position: any) => {
      if (resolved) return;
      resolved = true;
      const pos = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      setLocation(pos);
      setMyPos(pos); // <-- questo aggiorna il context e fa ricalcolare i tour vicini
    };

    // Fallback a bassa accuratezza (rete/IP): più veloce e quasi sempre
    // disponibile anche al primo accesso, quando non c'è ancora un fix GPS
    // in cache. Per la lista "tour vicini" basta una precisione grossolana.
    const tryLowAccuracy = () => {
      if (resolved) return;
      navigator.geolocation.getCurrentPosition(
        onSuccess,
        (err: any) => {
          console.log(err);
          setError(err.message);
        },
        { enableHighAccuracy: false, timeout: 30000, maximumAge: 1000 * 60 * 30 }
      );
    };

    // Primo tentativo: alta accuratezza con timeout AMPIO. Al primo accesso
    // il tempo include la concessione del permesso + l'acquisizione del primo
    // fix, che con 5s andava regolarmente in timeout senza mai chiamare
    // setMyPos (per questo i tour vicini comparivano solo se la posizione era
    // già stata concessa/cache in passato).
    navigator.geolocation.getCurrentPosition(
      onSuccess,
      (err: any) => {
        console.log(err);
        setError(err.message);
        // Timeout o posizione non disponibile: proviamo subito a bassa
        // accuratezza invece di arrenderci (e lasciare i tour vicini vuoti).
        tryLowAccuracy();
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 * 60 * 10 }
    );
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <>  </>
    // <Tooltip title={T('my_pos')}>
    //   {location ? (
    //       <MyLocation />
    //   ) : error ? (
    //     <div><LocationSearching /></div>
    //   ) : (
    //     <div>Acquisizione posizione...</div>
    //   )}
    // </Tooltip>
  );
}

export default LocationTracker;